import { render, staticRenderFns } from "./Synonyms.vue?vue&type=template&id=73a2d5f4&scoped=true"
import script from "./Synonyms.vue?vue&type=script&lang=js"
export * from "./Synonyms.vue?vue&type=script&lang=js"
import style0 from "./Synonyms.vue?vue&type=style&index=0&id=73a2d5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2d5f4",
  null
  
)

export default component.exports